<template>
  <section
    id="curriculum"
    class="co-bg-striped"
  >
    <div class="co-container-lg mx-auto px-4 py-20">
      <h2 class="co-heading-2-caption">
        短期間で結果を出す<br class="md:hidden">カリキュラム
      </h2>
      <p class="mb-[3.25rem] text-left md:text-center">
        あなたの現在の実力をもとに、もっとも効果的で無駄のないトレーニングメニューを設定します。
        <br class="hidden md:block">
        パーソナルメンターのメンタリングとオリジナル学習システムで目標到達まで最短距離で進みます。
      </p>
      <div class="mx-auto grid grid-cols-1 gap-x-20 gap-y-12 sm:max-w-[640px] lg:max-w-full lg:grid-cols-2">
        <div class="flex gap-x-5">
          <div class="mb-0 min-w-[50px] text-center">
            <img
              src="~/assets/images/Te/TeCourse/Python/Curriculum/curriculum-python.png"
              alt="Python"
              width="48"
              height="48"
            >
          </div>
          <div>
            <h3 class="co-display-10 mb-4 font-bold">
              Python
            </h3>
            <p class="mb-0">
              機械学習を応用したシステム開発で使われることが多いプログラミング言語です。人工知能（AI）への期待から人気が高まっています。Python3の基礎構文から学びます。
            </p>
          </div>
        </div>
        <div class="flex gap-x-5">
          <div class="mb-0 min-w-[50px] text-center">
            <img
              src="~/assets/images/Te/TeCourse/Python/Curriculum/curriculum-machine-learning.png"
              alt="機械学習"
              width="48"
              height="48"
            >
          </div>
          <div>
            <h3 class="co-display-10 mb-4 font-bold">
              機械学習
            </h3>
            <p class="mb-0">
              機械学習はAIの根幹となる技術の1つです。当コースでは機械学習の中から「教師あり学習」にフォーカスし、様々なデータから有用な規則を見つけ出す処理を学びます。
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
